// hooks/useAsthmaFlow.ts
import { useState } from 'react';
import { MildSectionKey, MedicationLogEntry, AssessmentData } from '../utils/asthmaTypes';
import { MEDICATION_GROUPS, DEFAULT_SELECTED_IDS } from '../utils/asthmaMedicationsData';

// Helper function for loading default medications
const getDefaultMedicationLabels = () => {
  const labels: string[] = [];
  MEDICATION_GROUPS.forEach(group => {
    group.options.forEach(opt => {
      if (DEFAULT_SELECTED_IDS.includes(opt.id)) {
        labels.push(opt.label);
      }
    });
  });
  return labels;
};

export function useAsthmaFlow() {
  const [openSection, setOpenSection] = useState<MildSectionKey>('INITIAL');
  const [medicationLog, setMedicationLog] = useState<MedicationLogEntry[]>([]);

  // Initialize with default medications so the button works immediately
  const [currentMedications, setCurrentMedications] = useState<string[]>(getDefaultMedicationLabels());

  const [secondRoundStarted, setSecondRoundStarted] = useState(false);
  const [thirdRoundStarted, setThirdRoundStarted] = useState(false);

  const [dosesAtStartOfRound2, setDosesAtStartOfRound2] = useState(0);
  const [dosesAtStartOfRound3, setDosesAtStartOfRound3] = useState(0);

  const [recheckDone, setRecheckDone] = useState(false);
  const [recheckResults, setRecheckResults] = useState<Record<number, AssessmentData>>({});

  const saveRecheck = (round: number, data: AssessmentData) => {
    setRecheckResults(prev => ({ ...prev, [round]: data }));
  };

  const handleDoseGiven = (givenAt: Date) => {
    if (currentMedications.length === 0) return;

    setMedicationLog((prev) => [
      ...prev,
      {
        doseNumber: prev.length + 1,
        time: givenAt,
        medications: currentMedications,
      },
    ]);
  };

  return {
    openSection, setOpenSection,
    medicationLog, setMedicationLog,
    currentMedications, setCurrentMedications,
    secondRoundStarted, setSecondRoundStarted,
    thirdRoundStarted, setThirdRoundStarted,
    recheckDone, setRecheckDone,
    handleDoseGiven,
    dosesAtStartOfRound2, setDosesAtStartOfRound2,
    dosesAtStartOfRound3, setDosesAtStartOfRound3,
    recheckResults, saveRecheck, setRecheckResults
  };
}